var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3337 2.49967C17.3337 1.58301 16.5837 0.833008 15.667 0.833008H2.33366C1.41699 0.833008 0.666992 1.58301 0.666992 2.49967V12.4997C0.666992 13.4163 1.41699 14.1663 2.33366 14.1663H15.667C16.5837 14.1663 17.3337 13.4163 17.3337 12.4997V2.49967ZM15.667 2.49967L9.00033 6.66634L2.33366 2.49967H15.667ZM15.667 12.4997H2.33366V4.16634L9.00033 8.33301L15.667 4.16634V12.4997Z",
    fill: "#27BCFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.52ef21f18ef862e3ef770f1365ae21b9.svg";
export { ForwardRef as ReactComponent };